import { render, staticRenderFns } from "./TabelaMapa.vue?vue&type=template&id=de256ff2&scoped=true"
import script from "./TabelaMapa.vue?vue&type=script&lang=js"
export * from "./TabelaMapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de256ff2",
  null
  
)

export default component.exports